/**
 * Проверяем если у вариантов товара отличаются цены, то вешаем классы на форму товара
 * @method
 */

export default (productFormNode, productData, salePricesClass, oldPricesClass) => {
  if (productData.price_min != productData.price_max) {
    productFormNode.classList.add(salePricesClass);
  }

  if (productData.variants && productData.variants.length) {
    const variantsOldPrices = productData.variants.map(item => item.old_price);
    const minVariantsOldPrice = Math.min(...variantsOldPrices);
    const maxVariantsOldPrice = Math.max(...variantsOldPrices);

    if (minVariantsOldPrice !== maxVariantsOldPrice) {
      productFormNode.classList.add(oldPricesClass);
    }
  }
};
